module.exports = __webpack_public_path__ + "img/progress-bar-progress2.fe8eacfa.svg";